import { Button } from "@chakra-ui/button";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
} from "@chakra-ui/modal";
import { FormControl, Checkbox, Text } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { ErrorMessage } from "../ErrorMessage/ErrorMessage";

interface UpdateCardAppVisibilityDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (isVisibleInApp: boolean) => Promise<void>;
  currentIsVisibleInApp?: boolean;
}

export const UpdateCardAppVisibilityDialog = ({
  isOpen,
  onClose,
  onConfirm,
  currentIsVisibleInApp = true,
}: UpdateCardAppVisibilityDialogProps) => {
  const [isVisibleInApp, setIsVisibleInApp] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const cancelRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isOpen) {
      setIsVisibleInApp(currentIsVisibleInApp);
      setIsLoading(false);
    }
  }, [isOpen, currentIsVisibleInApp]);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm(isVisibleInApp);
      onClose();
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      leastDestructiveRef={cancelRef}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader>Update App Visibility</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            <Text mb={4}>
              Control whether this card is visible in the mobile app.
            </Text>
            <FormControl>
              <Checkbox
                isChecked={isVisibleInApp}
                onChange={(e) => setIsVisibleInApp(e.target.checked)}
                isDisabled={isLoading}
              >
                Display card in mobile app
              </Checkbox>
            </FormControl>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose} isDisabled={isLoading}>
              Cancel
            </Button>
            <Button
              colorScheme="cherryButton"
              ml={3}
              onClick={handleConfirm}
              isDisabled={isLoading}
              isLoading={isLoading}
            >
              Update
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
